import BigCalendar from "react-big-calendar";

BigCalendar.tz = moment.tz.guess();
const m = (...args) => moment.tz(...args, BigCalendar.tz);
m.localeData = moment.localeData;

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(m));

import withDragAndDrop from "react-big-calendar/lib/addons/dragAndDrop";
export { withDragAndDrop };

import withTimezoneAwareness from "./withTimezoneAwareness";
export { withTimezoneAwareness };

export default BigCalendar;



// WEBPACK FOOTER //
// ./src/lib/utils/react-big-calendar/index.js